module.exports = __webpack_public_path__ + "static/lights4-fb687270bfff1c931ea0640304441162.jpg";